var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    { staticClass: "px-sm-0 pl-xl-3 mt-lg-3 mt-xl-0 col-12 col-xl-10" },
    [
      _c(
        "fieldset",
        { staticClass: "border border-primary p-2 rounded mt-3 " },
        [
          _c(
            "legend",
            {
              staticClass:
                "w-auto px-2 font-weight-bold smaller-font-content text-primary"
            },
            [_vm._v("Template Credentials")]
          ),
          _vm._v(" "),
          _c("b-form-group", { attrs: { "label-for": "" } }, [
            _c("div", { staticClass: "credentials row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "credential-field col-12 col-md-6 col-lg-4 col-xl-3",
                  on: {
                    click: function($event) {
                      return _vm.clearErrors("username")
                    }
                  }
                },
                [
                  _c("div", [
                    _c("label", [
                      _vm._v("Account Username"),
                      _c("span", { staticClass: "star" }, [_vm._v("*")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: { name: "username", type: "text" },
                    model: {
                      value: _vm.form.username,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.form,
                          "username",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.username"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "errorsection" }, [
                    _c(
                      "label",
                      {
                        staticClass: "text-error-msg",
                        style: {
                          visibility: _vm.errorFields.usernameError
                            ? "visible"
                            : "hidden"
                        }
                      },
                      [_vm._v(_vm._s(_vm.errorFields.usernameError))]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "credential-field col-12 col-md-6 col-lg-4 col-xl-3",
                  on: {
                    click: function($event) {
                      return _vm.clearErrors("newPassword")
                    }
                  }
                },
                [
                  _c("div", [_c("label", [_vm._v("Auto Template Id")])]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {},
                    [
                      _c("b-form-input", {
                        attrs: { name: "autotemplateid", type: "text" },
                        model: {
                          value: _vm.form.autoTemplateId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "autoTemplateId", $$v)
                          },
                          expression: "form.autoTemplateId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "errorsection" }, [
                    _c(
                      "label",
                      {
                        staticClass: "text-error-msg",
                        style: {
                          visibility: _vm.errorFields.autotemplateidError
                            ? "visible"
                            : "hidden"
                        }
                      },
                      [_vm._v(_vm._s(_vm.errorFields.autotemplateidError))]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "credential-field col-12 col-md-6 col-lg-4 col-xl-3",
                  on: {
                    click: function($event) {
                      return _vm.clearErrors("confirmPassword")
                    }
                  }
                },
                [
                  _c("div", [_c("label", [_vm._v("Property Template Id")])]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "password-field" },
                    [
                      _c("b-form-input", {
                        attrs: { name: "propertytemplateid", type: "text" },
                        model: {
                          value: _vm.form.propertyTemplateId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "propertyTemplateId", $$v)
                          },
                          expression: "form.propertyTemplateId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "errorsection" }, [
                    _c(
                      "label",
                      {
                        staticClass: "text-error-msg",
                        style: {
                          visibility: _vm.errorFields.propertytemplateidError
                            ? "visible"
                            : "hidden"
                        }
                      },
                      [_vm._v(_vm._s(_vm.errorFields.propertytemplateidError))]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "credential-field col-12 col-md-6 col-lg-12 col-xl-3"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.submitTemplateId()
                        }
                      }
                    },
                    [_c("span", { staticClass: "ml-1" }, [_vm._v("Save")])]
                  )
                ]
              )
            ])
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3875a452", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3875a452","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/agencies/EzlynxTemplateLogin.vue
// module id = null
// module chunks = 